import { Component } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

export interface FooterSocialLinkComponent {
  uid: string;
  name?: string;
  external?: boolean;
  locUrl?: string;
  socialNetwork?: string;
  title?: string;
  url?: string;
  target?: string;
}

@Component({
  selector: 'app-footer-social-link',
  templateUrl: 'footer-social-link.component.html',
  styleUrls: ['footer-social-link.component.scss'],
  standalone: false,
})
export class FooterSocialLinkComponent {
  data$: Observable<FooterSocialLinkComponent> = this.componentData.data$;

  constructor(private componentData: CmsComponentData<FooterSocialLinkComponent>) {}
}
